import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  Typography,
  Row,
  Form,
  Col,
  message,
} from 'antd';
import Select from 'components/Select';
import FormSubmitControls from 'components/FormSubmitControls';
import { postReasignarPlacas } from 'api/recaudacion';
import { getAsignacionDePlacas } from 'api/recaudacion/asignacionDePlacas';

const { Text } = Typography;

const ModalActionsPlacas = ({
  visible,
  setVisible,
  usuarios,
  change,
  usuario,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const fullNameUsuario = (_usuario = {}) => {
    const {
      first_name,
      last_name,
      second_last_name,
      email,
    } = _usuario;
    return `${first_name
      || ''} ${last_name
      || ''} ${second_last_name
      || ''} - ${email || ''}`;
  };

  const onFinish = async () => {
    setLoading(true);
    await form.validateFields();
    const values = form.getFieldsValue();
    const placas = await getAsignacionDePlacas({ usuario: usuario.id });
    if (placas.length) {
      if (change) {
        values.usuario_inicial = usuario.id;
      } else {
        values.usuario_inicial = usuario.id;
      }
      const updated = await postReasignarPlacas(values);
      if (updated) {
        setVisible(false);
        form.resetFields();
      }
    } else {
      message.warn(`No hay placas para asignadas al usuario ${fullNameUsuario(usuario)}`);
    }
    setLoading(false);
  };

  return (
    <Modal
      title={(
        <FormSubmitControls
          label={`${change ? 'Cambiar' : 'Baja de'} Placas`}
          loading={loading}
          onFinish={onFinish}
          onCancel={() => {
            form.resetFields();
            setVisible(false);
            setLoading(false);
          }}
        />
    )}
      className="modal-delete"
      visible={visible}
      footer={null}
      closable={false}
    >
      <Row>
        <Col span={24}>
          {change ? (
            <Form
              form={form}
              layout="vertical"
              onFinish={onFinish}
              scrollToFirstError
            >
              <Col span={24}>
                <Form.Item
                  name="usuario_final"
                  label="Usuario Receptor"
                >
                  <Select
                    dataSource={usuarios.filter((e) => e.id !== usuario.id)}
                    render={fullNameUsuario}
                  />
                </Form.Item>
              </Col>
            </Form>
          ) : (
            <Text>
              {`¿Desea dar de baja las placas del usuario ${fullNameUsuario(usuario)}?`}
            </Text>
          )}
        </Col>
      </Row>
    </Modal>
  );
};

ModalActionsPlacas.propTypes = {
  visible: PropTypes.bool,
  setVisible: PropTypes.func,
  usuarios: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  change: PropTypes.bool.isRequired,
  usuario: PropTypes.shape({
    id: PropTypes.number,
  }),
};

ModalActionsPlacas.defaultProps = {
  visible: false,
  setVisible: () => {},
  usuario: {},
};

export default ModalActionsPlacas;
